import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import * as Yup from "yup";
import React, { Suspense, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Form, FormikProvider, useFormik } from "formik";
// material
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { convertToHTML } from "draft-convert";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useTheme } from "@emotion/react";
import {
  Card,
  Grid,
  Stack,
  Select,
  TextField,
  Typography,
  FormControl,
  FormHelperText,
  Skeleton,
  MenuItem,
  Autocomplete,
  Divider,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Box,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormGroup,
  Switch,
} from "@mui/material";
import imageCompression from "browser-image-compression";

import * as api from "src/services";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { UploadMultiFile, UploadSingleFile } from "src/components/upload";
// import { Editor } from "react-draft-wysiwyg";
import { ContentState, convertFromHTML, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

// ----------------------------------------------------------------------
const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
  span: {
    fontSize: 12,
    float: "right",
    fontWeight: 400,
  },
}));

// ----------------------------------------------------------------------
export default function BlogForm({
  currentCategory,
  categoryLoading,
  isInitialized,
  currentProduct,
}) {
  const [editorState, setEditorState] = useState("");
  const queryClient = useQueryClient();
  const mode = useSelector((state) => state.settings.mode);
  const [mapDeleteIndex, setMapDeleteIndex] = useState(null);
  const [MultiImageLoading, setMultiImageLoading] = useState(false);
  const [multiEdit, setMultiEdit] = useState(true);
  const [multiEditDoc, setMultiEditDoc] = useState(true);
  const [imageLoading, setImageLoading] = useState(false);
  const [edit, setEdit] = useState(true);
  const { t } = useTranslation("product");
  const { blid } = useParams();
  const navigate = useNavigate();
  const { data: allBlogCategories } = useQuery(
    ["blog-category-list"],
    api.getAllBlogCategories
  );
  const { mutate: deleteGallery, isLoading: deleteLoading } = useMutation(
    api.singleDeleteFile,
    {
      onSuccess: () => {
        setMapDeleteIndex(null);
        queryClient.invalidateQueries([`get-product-details${blid}`]);
        toast.success(t(`common:errors.deleted-success`));
      },
    }
  );
  const { mutate: deleteSingleImageMutate, isLoading: deleteImageLoading } =
    useMutation(api.deleteSingleImage, {
      onSuccess: () => {
        setFieldValue("image", "");
      },
      onError: ({ response }) => {
        if (response.status === 409) {
          toast.error(`${response.data.message}`);
        } else {
          toast.error(`${response.data.message}`);
        }
      },
    });

  const {
    mutateAsync: uploadImage,
    isLoading: uploadImageLoading,
    data: uploadedImageResponse,
  } = useMutation(api.uploadImage, {
    onSuccess: (data) => {},
    onError: ({ response }) => {
      if (response.status === 409) {
        toast.error(`${response.data.message}`);
      } else {
        toast.error(`${response.data.message}`);
      }
    },
  });

  const { mutate, isLoading: updateLoading } = useMutation(
    blid ? api.updateBlog : api.addBlog,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`blogs-list`]);
        navigate("/blog/blogs_events");

        toast.success(
          blid ? `Blog updated successfully` : `Blog Added successfully`
        );
      },
      onError: ({ response }) => {
        if (response.status === 409) {
          toast.error(`${response.data.message}`);
        } else {
          toast.error(`${response.data.message}`);
        }
      },
    }
  );
  const NewProductSchema = Yup.object().shape({
    name: Yup.string().required(t("name-is-required")),
    description: Yup.string().required(t("description-is-required")),
    image: Yup.string(),
    category: Yup.array().min(1, "Category is required"),
    meta_description: Yup.string().required(t("meta-description-is-required")),
    meta_title: Yup.string().required(t("meta-title-is-required")),
    meta_tags: Yup.array().required(t("meta-tags-are-required")),
    slug: Yup.string().required(t("slug-is-required")),
    image: Yup.mixed().required("Image is required"),
    is_event: Yup.boolean(),
    is_active: Yup.boolean(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: currentProduct?.name || "",
      description: currentProduct?.description || "",
      category: currentProduct?.category || [],
      gallery: currentProduct?.gallery || [],
      image: currentProduct?.image || "",
      meta_description: currentProduct?.meta_description || "",
      meta_title: currentProduct?.meta_title || "",
      meta_tags: currentProduct?.meta_tags || [],
      slug: currentProduct?.slug || "",
      is_event: currentProduct?.is_event || false,
      is_active: currentProduct ? currentProduct?.is_active : true,
    },

    validationSchema: NewProductSchema,
    onSubmit: (values) => {
      mutate({ ...values, ...(currentProduct && { id: currentProduct._id }) });
    },
  });

  const {
    errors,
    values,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik;

  const handleRemoveAll = (key) => {
    if (key === "map") {
      setFieldValue("maps", []);
    } else {
      setFieldValue("gallery", []);
      setFieldValue("blob", []);
    }
  };
  function handleRemove(file, index) {
    if (!multiEditDoc) {
      setFieldValue(
        "blob",
        values.blob?.filter((item) => item !== file)
      );
    } else {
      setMapDeleteIndex(index);

      deleteGallery({ id: blid, type: "gallery", url: file });
      setFieldValue(
        "blob",
        values.blob?.filter((item) => item !== file)
      );
    }
  }
  const handleDrop = async (acceptedFiles) => {
    console.log(values, "INDROP");

    if (acceptedFiles[0]) {
      if (!!values.image) {
        setImageLoading(true);
        deleteSingleImageMutate(values.image);
      }
      setEdit(false);
      setImageLoading(true);
      const compressedFile = await imageCompression(acceptedFiles[0], {
        maxSizeMB: 0.1,
      });
      const myFile = new File([compressedFile], compressedFile.name, {
        type: compressedFile.type,
      });
      if (myFile) {
        Object.assign(myFile, {
          preview: URL.createObjectURL(myFile),
        });
        uploadImage([myFile])
          .then((res) => {
            setEdit(true);
            setFieldValue("image", res?.data[0]);
            setImageLoading(false);
          })
          .catch((err) => toast.error("Something went wrong"));
      }
    }
  };
  const handleMultiDrop = async (acceptedFiles) => {
    if (acceptedFiles[0]) {
      setMultiImageLoading(true);

      const filesArr = await Promise.all(
        acceptedFiles?.map(async (item) => {
          const compressedFile = await imageCompression(item, {
            maxSizeMB: 0.1,
          });
          return new File([compressedFile], compressedFile.name, {
            type: compressedFile.type,
          });
        })
      );

      uploadImage(filesArr).then((res) => {
        setMultiEdit(true);
        setFieldValue("gallery", res?.data);
        setMultiImageLoading(false);
      });
    }
  };

  useEffect(() => {
    const blocksFromHTML = convertFromHTML(`${values?.description}`);
    const content = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    setEditorState(() => EditorState.createWithContent(content));
  }, [Boolean(values?.description)]);

  console.log(values, "currentProduct");

  return (
    <Stack spacing={3}>
      <FormikProvider value={formik}>
        <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={7}>
              <Stack spacing={3}>
                <Card sx={{ p: 3 }}>
                  <Stack spacing={3}>
                    <Stack
                      direction={"row"}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        textAlign: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h4"
                        color={mode === "dark" ? "white" : "black"}
                      >
                        {blid
                          ? `Edit ${values?.is_event ? "Event" : "Blog"}`
                          : `Add ${values?.is_event ? "Event" : "Blog"}`}
                      </Typography>
                    </Stack>

                    <div>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          {isInitialized ? (
                            <Skeleton variant="text" width={140} />
                          ) : (
                            <LabelStyle>{"Blog Title"}</LabelStyle>
                          )}
                          {isInitialized ? (
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={56}
                            />
                          ) : (
                            <TextField
                              fullWidth
                              {...getFieldProps("name")}
                              error={Boolean(touched.name && errors.name)}
                              helperText={touched.name && errors.name}
                            />
                          )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          {isInitialized ? (
                            <Skeleton variant="text" width={140} />
                          ) : (
                            <LabelStyle>{t("slug")}</LabelStyle>
                          )}
                          {isInitialized ? (
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={56}
                            />
                          ) : (
                            <TextField
                              fullWidth
                              {...getFieldProps("slug")}
                              error={Boolean(touched.slug && errors.slug)}
                              helperText={touched.slug && errors.slug}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </div>

                    <div>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <FormControl
                            fullWidth
                            error={Boolean(touched.category && errors.category)}
                          >
                            {isInitialized ? (
                              <Skeleton variant="text" width={100} />
                            ) : (
                              <LabelStyle>{t("category")}</LabelStyle>
                            )}
                            {!categoryLoading ? (
                              <Select
                                multiple
                                {...getFieldProps("category")}
                                value={values.category}
                                id="grouped-native-select"
                              >
                                {allBlogCategories?.data?.map((item) => (
                                  <MenuItem value={item._id} key={item._id}>
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            ) : (
                              <Skeleton
                                variant="rectangular"
                                width={"100%"}
                                height={56}
                              />
                            )}
                            {touched.category && errors.category && (
                              <FormHelperText error sx={{ px: 2, mx: 0 }}>
                                {touched.category && errors.category}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                    </div>

                    <div>
                      {isInitialized ? (
                        <Skeleton variant="text" width={120} />
                      ) : (
                        <LabelStyle> {"Blog Content"} </LabelStyle>
                      )}
                      {isInitialized ? (
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={240}
                        />
                      ) : (
                        <Suspense fallback={<CircularProgress />}>
                          <Box
                            sx={{
                              border: "2px solid #ddd",
                              p: 2,
                              minHeight: 280,
                            }}
                          >
                            <Editor
                              placeholder="Blog description..."
                              editorState={editorState}
                              onEditorStateChange={(newEditorState) => {
                                setEditorState(newEditorState);
                                const htmlContent = convertToHTML(
                                  newEditorState.getCurrentContent()
                                );
                                setFieldValue("description", htmlContent);
                              }}
                              toolbar={{
                                options: [
                                  "inline",
                                  "list",
                                  "textAlign",
                                  "history",
                                ],
                              }}
                            />
                          </Box>
                        </Suspense>
                      )}
                    </div>
                  </Stack>
                </Card>
                <Card sx={{ p: 2 }}>
                  <Grid item xs={12}>
                    <Accordion
                      sx={{ border: "1px solid #ddd !important" }}
                      defaultExpanded
                    >
                      <AccordionSummary expandIcon={<KeyboardArrowDownIcon />}>
                        <Typography variant="h6" textAlign={"center"}>
                          META DATA
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div>
                          {isInitialized ? (
                            <Skeleton variant="text" width={120} />
                          ) : (
                            <LabelStyle> {t("meta-description")} </LabelStyle>
                          )}
                          {isInitialized ? (
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={240}
                            />
                          ) : (
                            <TextField
                              error={Boolean(
                                touched.meta_description &&
                                  errors.meta_description
                              )}
                              helperText={
                                touched.meta_description &&
                                errors.meta_description
                              }
                              fullWidth
                              {...getFieldProps("meta_description")}
                              rows={6}
                              multiline
                            />
                          )}
                        </div>

                        <Grid item xs={12}>
                          {isInitialized ? (
                            <Skeleton variant="text" width={120} />
                          ) : (
                            <LabelStyle> {t("meta-title")} </LabelStyle>
                          )}
                          {isInitialized ? (
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={240}
                            />
                          ) : (
                            <TextField
                              error={Boolean(
                                touched.meta_title && errors.meta_title
                              )}
                              helperText={
                                touched.meta_title && errors.meta_title
                              }
                              fullWidth
                              {...getFieldProps("meta_title")}
                            />
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          {isInitialized ? (
                            <Skeleton variant="text" width={120} />
                          ) : (
                            <LabelStyle> {t("meta-tags")} </LabelStyle>
                          )}
                          {isInitialized ? (
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={240}
                            />
                          ) : (
                            <Autocomplete
                              multiple
                              value={values.meta_tags || []}
                              options={
                                values.meta_tags.map((item) =>
                                  item.toString()
                                ) ?? []
                              }
                              freeSolo
                              onChange={(_, val) =>
                                setFieldValue("meta_tags", val)
                              }
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    variant="outlined"
                                    label={option}
                                    {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          )}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </Card>
              </Stack>
            </Grid>
            <Grid item xs={12} md={5}>
              <Card sx={{ p: 3 }}>
                <Grid item xs={12}>
                  <FormControl>
                    <Typography>Is this an event ?</Typography>
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue={false}
                      name="radio-buttons-group"
                      {...getFieldProps("is_event")}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Stack spacing={3} pb={1}>
                  <div>
                    {isInitialized ? (
                      <Skeleton variant="text" width={150} />
                    ) : (
                      <LabelStyle>{"featured Image"}</LabelStyle>
                    )}
                    {isInitialized ? (
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={225}
                      />
                    ) : (
                      <UploadSingleFile
                        file={values.image}
                        accept={{
                          "image/png": [
                            ".png",
                            ".jpg",
                            ".jpeg",
                            ".webp",
                            ".svg",
                          ],
                        }}
                        isEdit={edit}
                        setImageLoading={setImageLoading}
                        onDrop={handleDrop}
                        error={Boolean(touched.image && errors.image)}
                        category
                        loading={imageLoading || deleteImageLoading}
                      />
                    )}
                    {touched.cover && errors.cover && (
                      <FormHelperText error sx={{ px: 2, mx: 0 }}>
                        {touched.cover && errors.cover}
                      </FormHelperText>
                    )}
                  </div>

                  <div>
                    {isInitialized ? (
                      <Skeleton variant="text" width={150} />
                    ) : (
                      <LabelStyle>{"Gallery"}</LabelStyle>
                    )}
                    {isInitialized ? (
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={225}
                      />
                    ) : (
                      <>
                        <UploadMultiFile
                          showPreview
                          isEdit={multiEdit}
                          accept={{
                            "image/png": [
                              ".png",
                              ".jpg",
                              ".jpeg",
                              ".webp",
                              ".svg",
                            ],
                          }}
                          files={multiEdit ? values.gallery : values.blob}
                          loading={false}
                          imageLoading={MultiImageLoading}
                          onDrop={handleMultiDrop}
                          deleteIndex={mapDeleteIndex}
                          onRemove={handleRemove}
                          onRemoveAll={() => handleRemoveAll("gallery")}
                          blob={values.blob}
                          error={Boolean(touched.gallery && errors.gallery)}
                        />
                        {touched.gallery && errors.gallery && (
                          <FormHelperText error sx={{ px: 2 }}>
                            {touched.gallery && errors.gallery}
                          </FormHelperText>
                        )}
                      </>
                    )}
                  </div>
                  <Stack>
                    <FormGroup sx={{ float: "right" }}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={values?.is_active}
                            setFieldValue={setFieldValue}
                            {...getFieldProps("is_active")}
                          />
                        }
                        label={t("is active")}
                      />
                    </FormGroup>
                  </Stack>
                  <Stack spacing={2}>
                    {isInitialized ? (
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={56}
                      />
                    ) : (
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        size="large"
                        fullWidth
                        loading={updateLoading}
                      >
                        {blid ? "Update" : "Add"}
                      </LoadingButton>
                    )}
                  </Stack>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </Form>
      </FormikProvider>
    </Stack>
  );
}
